var View;
(function(View) {
    View["Information"] = "information";
    View["Customize"] = "customize";
})(View || (View = {}));

export { View };
